<div mat-dialog-title class="modal-title">
  <mat-icon>card_membership</mat-icon>
  <span>Editar datos básicos</span>
  <mat-icon class="close-button" (click)="confirmCloseModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  @if (isLoadingData) {
    <div class="loading-page">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  }

  @if (!isLoadingData && !receivedCourse) {
    <div class="no-current"> ENFAF Academy no está disponible </div>
  }

  @if (!isLoadingData && receivedCourse) {
    <div class="thumbnail" (click)="membersThumbnail.click()">
      @if (!currentThumbnail && !imageToUploadSrc) {
        <div class="hint">
          <mat-icon> add_photo_alternate </mat-icon>
          <span> Imagen 1 : 1 </span>
        </div>
      }
      @if (currentThumbnail && !imageToUploadSrc) {
        <img [src]="currentThumbnail" />
      }

      @if (imageToUploadSrc) {
        <img [src]="imageToUploadSrc" />
      }
      <input
        #membersThumbnail
        type="file"
        name="membersThumbnail"
        id="membersThumbnail"
        class="membersThumbnail"
        accept=".jpg, .png"
        (change)="onSelectImage($event)"
      />
    </div>
    <form [formGroup]="membersForm" class="row">
      <div class="col-12">
        <div class="form-control hidden">
          <mat-slide-toggle color="primary" formControlName="hidden"> ¿Ocultar ENFAF Academy? </mat-slide-toggle>
        </div>
      </div>
      <div class="col-12">
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Nombre de ENFAF Academy</mat-label>
            <input matInput type="text" placeholder="Nombre de ENFAF Academy" formControlName="name" name="name" autocomplete="off" />
            <mat-error> Nombre de ENFAF Academy requerido </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12">
        <div class="upload-files">
          <span>Sube recursos para este curso</span>
          <enfaf-dropzone
            [acceptMultiple]="true"
            [acceptLimit]="10"
            [acceptBigFiles]="true"
            filesToAccept="*"
            (filesDropped)="onDroppedAttachments($event)"
          >
          </enfaf-dropzone>
        </div>
      </div>
      @if (currentAttachments.length) {
        <div class="col-12 remote-attachments">
          <enfaf-remote-attachments
            [remoteAttachments]="currentAttachments"
            title="Recursos existentes de este curso"
            [isDeletingRemoteAttachment]="isDeletingRemoteAttachment"
            (onDeleteRemoteAttachment)="onDeleteRemoteAttachment($event)"
          >
          </enfaf-remote-attachments>
        </div>
      }
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="confirmCloseModal()"> Cerrar </button>
  <button mat-flat-button color="primary" (click)="saveMembers()" [disabled]="membersForm.invalid || isSavingMembers">
    @if (!isSavingMembers) {
      <span>Guardar</span>
    } @else {
      <mat-spinner class="white-spinner"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
